export const environment = {
  production: false,
  apiUrl: "https://dev.api.medicarelee.net/api/",
  wsUrl: "wss://dev.api.medicarelee.net",
};
